import React, { useState, useEffect } from 'react';
import '../Login/Modal.css';
import '../Accounts/UserFormModal.css';
import './CompanyModal.css';

const EMPTY_FORM = {
  label: '',
  name: '',
  nameEn: '',
  address: '',
  addressEn: '',
  tel: '',
  fax: '',
};

const CompanyModal = ({ show, onClose, onSaved, company, isEdit }) => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState('');

  useEffect(() => {
    if (company && isEdit) {
      setFormData({
        label: company.label || '',
        name: company.name || '',
        nameEn: company.nameEn || '',
        address: company.address || '',
        addressEn: company.addressEn || '',
        tel: company.tel || '',
        fax: company.fax || '',
      });
    } else {
      setFormData(EMPTY_FORM);
    }
    setErrors({});
    setApiError('');
  }, [company, isEdit, show]);

  const validate = () => {
    const newErrors = {};
    if (!formData.label.trim()) newErrors.label = '請輸入公司簡稱';
    if (!formData.name.trim()) newErrors.name = '請輸入公司名稱';
    return newErrors;
  };

  const handleChange = (field) => (e) => {
    setFormData(prev => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) setErrors(prev => ({ ...prev, [field]: '' }));
    if (apiError) setApiError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setSaving(true);
    setApiError('');

    const token = localStorage.getItem('token');
    const API = process.env.REACT_APP_API_URL || '/api';

    try {
      const url = isEdit
        ? `${API}/companies/${company._id}`
        : `${API}/companies`;
      const res = await fetch(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!res.ok) {
        const data = await res.json();
        setApiError(data.message || '儲存失敗');
        setSaving(false);
        return;
      }

      setSaving(false);
      if (onSaved) onSaved();
      onClose();
    } catch (err) {
      setApiError('網路錯誤，請稍後再試');
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg company-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEdit ? '編輯公司資訊' : '新增公司'}</h3>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {apiError && <div className="company-modal-error">{apiError}</div>}

            <div className="form-row">
              <div className="form-group">
                <label>公司簡稱 *</label>
                <input
                  type="text"
                  className={`form-control ${errors.label ? 'is-invalid' : ''}`}
                  value={formData.label}
                  onChange={handleChange('label')}
                  placeholder="例如：皇聚"
                />
                {errors.label && <div className="invalid-feedback">{errors.label}</div>}
              </div>
              <div className="form-group">
                <label>公司名稱 *</label>
                <input
                  type="text"
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  value={formData.name}
                  onChange={handleChange('name')}
                  placeholder="例如：皇聚食品國際有限公司"
                />
                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
              </div>
            </div>

            <div className="form-row">
              <div className="form-group form-group-full">
                <label>公司名稱（英文）</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.nameEn}
                  onChange={handleChange('nameEn')}
                  placeholder="e.g. Huang Ju Food International Co., Ltd."
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group form-group-full">
                <label>地址</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.address}
                  onChange={handleChange('address')}
                  placeholder="例如：新北市新店區安和路二段217巷9號15樓"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group form-group-full">
                <label>地址（英文）</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.addressEn}
                  onChange={handleChange('addressEn')}
                  placeholder="e.g. 15F, No. 9, Ln. 217, Sec. 2, Anhe Rd."
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Tel</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.tel}
                  onChange={handleChange('tel')}
                  placeholder="例如：+886-2-2212-6149"
                />
              </div>
              <div className="form-group">
                <label>Fax</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.fax}
                  onChange={handleChange('fax')}
                  placeholder="例如：+886-2-2212-6349"
                />
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>
              取消
            </button>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? '儲存中...' : (isEdit ? '更新' : '新增')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyModal;
